import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import Button from '~components/ui/Button'
import moment from 'moment'
import classNames from 'classnames'

class Modal extends Component {
  handleStockDueDate (date) {
    if (!date) {
      return 'TBC'
    }

    // Strip century from the date (Hogan date format)
    date = date.toString().slice(1)

    // Parse the date
    const dueDate = moment(date, 'YYMMDD')

    // If the date is valid, format it
    if (dueDate.isValid()) {
      return dueDate.format('DD/MMM/YYYY')
    }

    // Otherwise, return TBC
    return 'TBC'
  }

  render () {
    const { cartItems } = this.props

    return (
      <div className="fixed z-60 p-4 md:p-8 flex flex-col top-0 left-0 right-0 bottom-0 bg-charcoal bg-opacity-75">
        <div className="bg-white sm:bg-lightGrey w-full m-auto max-w-screen-mdxl px-4 py-8 sm:p-15 sm:pb-0 overflow-scrolling overflow-x-hidden overflow-y-auto relative">
          <button type="button" className="w-10 h-10 absolute top-3 right-1 sm:top-8 sm:right-7 block" aria-label="Close" onClick={this.props.onClose}>
            <span className="w-4 h-4 icon icon-fill block m-auto" aria-hidden="true">
              <Sprite name="cross" />
            </span>
          </button>

          <h3 className="text-md lg:text-2xl border-b border-coral pb-6 pr-6">
            {this.props.title}
          </h3>

          {this.props.text && (
            <div className="mt-7 w-full sm:w-1/2 editor editor-standard">
              <p>
                {this.props.text}
              </p>
            </div>
          )}

          {cartItems && (
            <>
              <span className="mt-10 block text-base lg:text-md border-charcoal pb-4 border-b">
                Your items
              </span>

              <ol className="mt-7 -mb-2 list-inside list-decimal">
                {cartItems.map((item) => {
                  const { id, name, size, qty, stock, stockDueQty, stockDueDate } = item
                  const date = this.handleStockDueDate(stockDueDate)
                  const hasBackOrder = qty >= (qty - stockDueQty)
                  const backorderStockQty = qty - stock

                  return (
                    <li
                      className="mb-2 block"
                      key={id}
                    >
                      <span className={classNames('font-bold mr-2')}>
                        {`${qty} ${name}: ${size} (${stock} in stock, `}

                        <span className={classNames({ 'text-red': hasBackOrder })}>
                          {`${backorderStockQty} expected arrival date: ${date}`}
                        </span>
                        )
                      </span>

                      <span className="mr-2">
                        -
                      </span>

                      <button type="button" className="underline hover:no-underline focus:no-underline" onClick={() => this.props.onClearForwardOrderItem(id)}>
                        remove items not available for immediate delivery
                      </button>
                    </li>
                  )
                })}
              </ol>
            </>
          )}

          {cartItems.length === 0 && (
            <span className="mt-7 -mb-2 block">
              There are no more items that exceed stock levels.
            </span>
          )}

          <div className="mt-12 flex flex-wrap -mx-2 sm:bg-white sm:py-8 relative before:bg-white after:bg-white before:-left-max after:-right-max content-after content-before sm:content-before sm:content-after before:absolute after:absolute before:w-max after:w-max before:top-0 after:top-0 before:h-full after:h-full" tw-content-before="" tw-content-after="">
            <div className="w-full px-2 my-2 sm:w-1/2">
              <Button
                theme="black-to-red"
                className="w-full"
                onClick={this.props.onCancel}
              >
                Cancel
              </Button>
            </div>

            <div className="w-full px-2 my-2 sm:w-1/2">
              <Button
                onClick={this.props.onConfirm}
                theme="green-to-pink"
                className="w-full"
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  cartItems: PropTypes.array,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  onClearForwardOrderItem: PropTypes.func,
  className: PropTypes.string
}

export default Modal
